import {Component, Input} from '@angular/core';
import {EventItem, EventStatus, Lookups} from "@model";

@Component({
  selector: 'app-event-list-item-header',
  templateUrl: './event-list-item-header.component.html',
  styleUrls: ['./event-list-item-header.component.scss']
})
export class EventListItemHeaderComponent {
  @Input() eventItem: EventItem | undefined;
  @Input() languages: Lookups[] = [];
  @Input() defaultLanguage: number | undefined;

  protected readonly EventStatus = EventStatus;
}
